namespace advisorop.components.meetinghub {
    export class InvestorMeetingSchedulerController {
        meetingId: string;
        participantId: string;
        meeting: domains.IMeeting;
        availableMeetingTimes: Array<domains.IMeetingAvailabilityDuration>;
        currentParticipant: domains.IMeetingParticipant;

        _meetingHubService: services.MeetingHubService;

        constructor(private meetingHubService: services.MeetingHubService, private advisorService: services.AdvisorService, private $scope: ng.IScope) {
            this._meetingHubService = meetingHubService
        }

        loadMeeting(): void {
            this.currentParticipant = undefined;
            this._meetingHubService.getUnscheduledMeeting(this.meetingId, this.participantId)
                .then(result => {
                    this.meeting = result.data;
                });
        }

        showScheduler(): boolean {
            var ret = this.meeting == undefined || this.meeting.status == domains.MeetingStatus.SCHEDULELATER;
            return ret;
        }

        getAvailableMeetingTimes(): void {
            this.advisorService.getAdvisorAvailableMeetingTimes(this.meetingId).then(resp => {
                this.availableMeetingTimes = resp.data.concat();
                console.log(resp);
            }).catch(err => {
                console.log(err);
            })
        }

        createMeeting(): void {
            this._meetingHubService.createMeeting(this.meeting).then(result => {
                this.meeting = result.data
                console.log(result);
            }).finally(() => {
                this.$scope.$apply();
            })
        };

        $onInit(): void {
        }

        $routerOnActivate(next, previous) {
            this.meetingId = next.params.meetingId;
            this.participantId = next.params.participantId;
            this.loadMeeting();
            this.getAvailableMeetingTimes();
        }

    }

    class InvestorMeetingScheduler implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
            };
            this.controller = [`meetingHubService`, 'advisorService', '$scope',InvestorMeetingSchedulerController];
            this.controllerAs = `vm`;
            this.templateUrl = `spa/meeting-hub-module/views/investor-meeting-scheduler.html`;
        }
    }
    angular.module(Constants.APP).component(`investorMeetingScheduler`, new InvestorMeetingScheduler());
}